import { ca } from '@cian/analytics';

import { EPeriodicity } from '../../services/fetchChatbotMessages';

export const trackAnswerQuestionsClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Click_sopr',
    label: 'Answer',
    page: {
      extra: {
        chat_id: 'chatbot',
      },
    },
  });
};

export const trackShowMoreClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Click_sopr',
    label: 'ShowMore',
    page: {
      extra: {
        chat_id: 'chatbot',
      },
    },
  });
};

export const trackSendMoreClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Click_sopr',
    label: 'SendMore',
    page: {
      extra: {
        chat_id: 'chatbot',
      },
    },
  });
};

export const trackNewSearchClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Click_sopr',
    label: 'NewSearch',
    page: {
      extra: {
        chat_id: 'chatbot',
      },
    },
  });
};

export const trackStopSearchClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Click_sopr',
    label: 'Stop',
    page: {
      extra: {
        chat_id: 'chatbot',
      },
    },
  });
};

export const trackShowAllClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Click_sopr',
    label: 'ShowAll',
    page: {
      extra: {
        chat_id: 'chatbot',
      },
    },
  });
};

export const trackTuneFrequencyClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Click_sopr',
    label: 'TuneFrequency',
    page: {
      extra: {
        chat_id: 'chatbot',
      },
    },
  });
};

const AnalyticsPeriodicity: { [key in EPeriodicity]: string } = {
  [EPeriodicity.Daily]: 'Daily',
  [EPeriodicity.EveryThreeDays]: 'ThreeDays',
  [EPeriodicity.Weekly]: 'Weekly',
  [EPeriodicity.Never]: 'Never',
};

export const trackSetFrequencyClick = (periodicity?: EPeriodicity) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Click_sopr',
    label: periodicity ? AnalyticsPeriodicity[periodicity] : 'Unchanged',
    page: {
      extra: {
        chat_id: 'chatbot',
      },
    },
  });
};

export const trackActionButtonClick = (analyticsType: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Click_sopr',
    label: analyticsType,
    page: {
      extra: {
        chat_id: 'chatbot',
        click_source: 'chat',
      },
    },
  });
};
